import React, { FC, ReactNode } from 'react';
import { StyledResidenceParam } from './styled';
import { FlexCenterAligned } from '../../../styled/common';

interface ResidenceParamProps {
  param: string;
  icon: ReactNode;
  hideOnMobile?: boolean;
  cypress?: string;
}

export const ResidenceParam: FC<ResidenceParamProps> = ({
  param,
  icon,
  hideOnMobile,
  cypress
}) => (
  <StyledResidenceParam $hideOnMobile={hideOnMobile} data-cy={cypress}>
    <FlexCenterAligned>{icon}</FlexCenterAligned>
    <span>{param}</span>
  </StyledResidenceParam>
);
